// 👇️ ts-nocheck ignores all ts errors in the file
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-nocheck
import { message } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { refreshTableKitsProducts, selectKitsProductsRefreshTable } from "../../../redux";
import { TableProperties } from "../../../shared/components/ui/Table/types";
import { kitsProductsService, productsService } from "../../../shared/services";
import useAppDispatch from '../../../redux/hooks/useAppDispatch';


interface Product {
    id:                      number;
    name:                    string;
    price:                   number;
    price_with_tax:          number;
    discount_price:          number;
    discount_price_whit_tax: number;
    status:                  string;
    slug:                    string;
    course:                  string;
    quantity?:               number;
    type_media?:             string;
    main_image?:             string | null;
    products_media_id?:      number;
}

export interface ISingleProductForKit {
    id:         number;
    kit_id:     number;
    product_id: number;
    quantity:   number;
    createdAt:  Date;
    updatedAt:  Date;
    deletedAt:  null;
    product:    Product;
}

type ProductOption = {
  value: string;
  title: string;
  disabled?: boolean;
  stock: number;
};

export const useKitsProducts = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const isRefreshTableKitsProducts = useSelector(selectKitsProductsRefreshTable);
    const { pathname  } = useLocation();
    const {id} =useParams()
    const [isLoading, setIsLoading] = useState(false);
    const [tableProps, setTableProps] = useState<TableProperties>();
    const [selectedValue, setSelectedValue] = useState<string>()
    const [quantity, setQuantity] = useState<number>(1)
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
    const [data_value, setDataValue] = useState<string>()
    const [arrOptionsProducts, setArrOptionsProducts] = useState<ProductOption[]>([])
    const [productsStockById, setProductsStockById] = useState<Record<string, number>>({})

      const changeSelectValue = (val: string) => {
        setSelectedValue(val);
      };

      const changeQuantity = (val: number) => {
        setQuantity(val);
      };
      
      const onInputKeyDown = (e: any) => {
        setDataValue(e)
      };
      
      useEffect(() => {
        if(data_value){
          serviceSelector()
        }
      }, [data_value])
      

    useEffect(() => {
        const kitId = pathname.split("/")[2];
        if (kitId === "new") return;
        if (isNaN(Number(kitId))) {
          navigate(`/kits`);
          return;
        }
        if (arrOptionsProducts.length === 0) {
          serviceSelector();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [pathname]);
    const serviceSelector = async() => {
      const query = {
        $limit: 20,
        status: "active",
        data_value: data_value,
      };
        await productsService.find({ query }).then(({data}: Product[]) =>{
          const stockMap: Record<string, number> = {};
          const options = (data || []).map((item: Product) => {
            const stock = Math.max(0, Number(item.quantity ?? 0) || 0);
            const idStr = item.id.toString();
            stockMap[idStr] = stock;
            const withoutStock = stock < 1;
            return {
              value: idStr,
              title: withoutStock
                ? `${item.name} (sin stock)`
                : `${item.name} (stock: ${stock})`,
              disabled: withoutStock,
              stock,
            };
          });
          setProductsStockById((prev) => ({ ...prev, ...stockMap }));
          setArrOptionsProducts(options);
        })
      }
      const onSubmitCreateProductForKit = async (): Promise<boolean> => {
        if (isLoading) return false;
        setIsLoading(true);
        if (!selectedValue) {
          setIsLoading(false);
          message.error(
            `Debes de seleccionar un producto antes de añadirlo al kit`
          );
          return false;
        }

        let stock = productsStockById[selectedValue];
        if (stock == null) {
          try {
            const product = await productsService.get(Number(selectedValue));
            stock = Math.max(0, Number(product?.quantity ?? 0) || 0);
            setProductsStockById((prev) => ({
              ...prev,
              [selectedValue]: stock,
            }));
          } catch {
            setIsLoading(false);
            message.error("No se pudo validar el stock del producto");
            return false;
          }
        }

        if (stock < 1) {
          setIsLoading(false);
          message.error(
            "No puedes agregar este producto al kit: no tiene stock"
          );
          return false;
        }

        if (quantity > stock) {
          setIsLoading(false);
          message.error(
            `La cantidad supera el stock disponible (stock: ${stock})`
          );
          return false;
        }

        try {
          const res = await kitsProductsService.create({
            product_id: Number(selectedValue),
            kit_id: Number(id),
            quantity,
          });
          setIsLoading(false);
          if (res?.id) {
            message.success(
              `Se ha añadido con éxito el producto al kit con id:${res.id}`
            );
            dispatch(refreshTableKitsProducts(true));
            return true;
          }
          message.error("No se pudo agregar el producto al kit");
          return false;
        } catch (err: any) {
          setIsLoading(false);
          message.error(
            err?.message || "No se pudo agregar el producto al kit"
          );
          return false;
        }
      };


    useEffect(() => {
        if (isRefreshTableKitsProducts) {
          tableProps?.refresh();
          dispatch(refreshTableKitsProducts(false));
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [isRefreshTableKitsProducts]);

  return {
    id,
    isLoading,
    isRefreshTableKitsProducts,
    tableProps,
    arrOptionsProducts,
    selectedValue,
    quantity,
    modalIsOpen,
    setTableProps,
    setModalIsOpen,
    onSubmitCreateProductForKit,
    changeSelectValue,
    changeQuantity,
    onInputKeyDown,
  }
}
